'use strict';

$(document).ready(function () {
    if ($('#giftvoucher-others').is(':checked')) {
        var form = $('.giftvoucher-start-form');
        form[0].reset();
        $('#giftvoucher-others, .giftvoucher-accept').prop('checked', false);
        $('#giftvoucher-myself').prop('checked', true);
    }
    $('.voucher-for-others').on('click', function () {
        $('.giftvoucher-form-forothers').removeClass('d-none');
        $('.mail-icon-checkbox').prop('checked', true).prop('disabled', true);
    });

    $('.voucher-for-myself').on('click', function () {
        var $form = $('.giftvoucher-form-forothers');
        $form.addClass('d-none');
        $('.giftvoucher-date-picker').addClass('d-none');
        $form.find('input:not(#receiverCountryCode), textarea, select').val('');
        $form.find('input[type=checkbox], input[type=radio]').prop('checked', false);
        $('#giftvoucher-sendnow').prop('checked', true);
        $form.find('.regexError, .invalid-feedback-recivercontact, .is-invalid, .d-block').removeClass('is-invalid d-block');
    });

    $('.schedule-trigger-pointer').on('click', function () {
        $('.giftvoucher-date-picker').removeClass('d-none');
        // Set current date in the date trigger input
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
        var yyyy = today.getFullYear();
        var currentDate = dd + '/' + mm + '/' + yyyy;
        $('.giftvoucher-data-trigger').val(currentDate);
    });

    $('.schedule-prohibit-pointer').on('click', function () {
        $('.giftvoucher-date-picker').addClass('d-none').removeClass('is-invalid');
        $('.invalid-feedback-deliverydate').text('').removeClass('d-block');
    });

    $('body').on('input', '#receiverName', function () {
        var $this = $(this);
        $this.val($this.val().trimStart().replace(/[^a-zA-Z ]/g, ''));
    });

    $('body').on('input', '#receiverMobileNumber', function () {
        $(this).val($(this).val().replace(/[^0-9]/g, ''));
    });
    $('body').on('click', '.giftvoucher-accept', function () {
        if ($(this).is(':checked')) {
            $('.gift-voucher-error').addClass('d-none');
        }
    });
    // Term and Conditions Model
    $('.giftvoucher-readmore').on('click', function (e) {
        e.preventDefault();
        if (!$('.giftvoucher-accept').is(':checked')) {
            $('#giftvoucher-terms-modal').modal('show');
        } else {
            $('.giftvoucher-accept').prop('checked', false);
        }
        return false;
    });

    $('.ckc-checkbox').on('click', function (e) {
        e.preventDefault();
        if (!$('.giftvoucher-accept').is(':checked')) {
            $('#giftvoucher-terms-modal').modal('show');
        } else {
            $('.giftvoucher-accept').prop('checked', false);
        }
    });

    $('#giftvoucher-agree-btn').on('click', function () {
        $('.giftvoucher-accept').prop('checked', true);
        $('#giftvoucher-terms-modal').modal('hide');
        $('.gift-voucher-error').addClass('d-none');
    });

    var $giftVocherDataInput = $('.giftvoucher-data-trigger');
    if ($giftVocherDataInput && $giftVocherDataInput.length) {
        $.fn.datepicker.dates.en.daysMin = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        $('.giftvoucher-data-trigger')
            .datepicker('destroy')
            .datepicker({
                format: 'dd/mm/yyyy',
                language: 'en',
                autoclose: true,
                todayHighlight: false,
                startDate: '+0d',
                weekStart: 1,
                maxViewMode: 2
            })
            .datepicker('setDate', new Date())
            .on('show', function (e) {
                e.stopPropagation();
            });

        $('.giftvoucher-data-trigger').on('click', function () {
            $('.table-condensed .prev').text('');
            $('.table-condensed .next').text('');
        });
    }
});
